import SectionAmbientGradient from './SectionAmbientGradient.jsx';
import SectionTopWave from './SectionTopWave.jsx';
import ConveniosHomeSection from './ConveniosHomeSection.jsx';

/**
 * Bloque oscuro: solo convenios (créditos = blanco, sedes = verde aparte).
 */
export default function HomeBenefitsBand({ convenios, loading }) {
  return (
    <section
      id="beneficios"
      className="relative isolate scroll-mt-24 overflow-hidden border-t border-white/10 bg-brand-navy pb-16 pt-12 lg:pb-20 lg:pt-14"
    >
      <SectionAmbientGradient />
      <SectionTopWave />

      <div className="relative z-[2] mx-auto max-w-7xl px-6 lg:px-8">
        <ConveniosHomeSection items={convenios} loading={loading} embedded />
      </div>
    </section>
  );
}
